export default __webpack_public_path__ + "static/media/JobCard3.a1d2e8ef.jpeg";